var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversation-date"},[_c('span',{staticClass:"conversation-date__label small"},[_vm._v(_vm._s(_vm.getDate()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }